/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { ZodError, z } from 'zod';

import {
  ValidateTeamIdDocument,
  type ValidateTeamIdQuery,
  type ValidateTeamIdQueryVariables,
} from '@fai/friendli-suite/generated/client/graphql';
import client from '@fai/friendli-suite/shared/apollo/base-link';

const teamNameSchema = z
  .object({
    id: z.string(),
    /**
     * BE Schema is nullable string but it should give a
     * 'PERSONAL' fallback string if user refused to enter team's name
     */
    name: z.string(),
  })
  .optional();

// eslint-disable-next-line consistent-return
export async function getTeamName({ teamId }: { teamId: string }) {
  const { data } = await client.query<ValidateTeamIdQuery, ValidateTeamIdQueryVariables>({
    query: ValidateTeamIdDocument,
    variables: { teamId },
    fetchPolicy: 'network-only',
  });

  const response = teamNameSchema.safeParse(data?.clientTeam);

  if (response.success) {
    return response.data?.name;
  }

  throw new ZodError(response.error.issues);
}
